import { tFunction } from 'app/lang';
import validateEmail from 'app/lib/form/validation-utils/validateEmail';

import type { InitialValues } from './EmailCollectorContent';

import dictionary from './EmailCollector.dictionary.json';

type EmailErrors = {
  email?: string;
};

export const getValidate = (t: tFunction) => {
  return (values: InitialValues): EmailErrors => {
    const errors: EmailErrors = {};

    if (!values.email || !validateEmail(values.email)) {
      errors.email = t(dictionary.errorEmail);
    }

    return errors;
  };
};
